var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaseStatusWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.375 12.5C2.375 12.1548 2.65483 11.875 3 11.875H13C13.3452 11.875 13.625 12.1548 13.625 12.5C13.625 12.8452 13.3452 13.125 13 13.125H3C2.65483 13.125 2.375 12.8452 2.375 12.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 1.875C9.46444 1.875 8.625 2.71447 8.625 3.75V10C8.625 10.3452 8.90481 10.625 9.25 10.625C9.59519 10.625 9.875 10.3452 9.875 10V3.75C9.875 3.40482 10.1548 3.125 10.5 3.125C10.8452 3.125 11.125 3.40482 11.125 3.75V10C11.125 10.3452 11.4048 10.625 11.75 10.625C12.0952 10.625 12.375 10.3452 12.375 10V3.75C12.375 2.71447 11.5356 1.875 10.5 1.875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 5.625C4.46447 5.625 3.625 6.46444 3.625 7.5V10C3.625 10.3452 3.90483 10.625 4.25 10.625C4.59518 10.625 4.875 10.3452 4.875 10V7.5C4.875 7.15481 5.15482 6.875 5.5 6.875C5.84518 6.875 6.125 7.15481 6.125 7.5V10C6.125 10.3452 6.40482 10.625 6.75 10.625C7.09519 10.625 7.375 10.3452 7.375 10V7.5C7.375 6.46444 6.53553 5.625 5.5 5.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseStatusWhite);
export default __webpack_public_path__ + "static/media/caseStatusWhite.22fd5497f0af9dcd090c40c69486f841.svg";
export { ForwardRef as ReactComponent };